import Idioma from '../Idioma'
export default new Idioma({
  idioma:'es',
  pasos: {
    uno: 'Haz tú reserva',
    dos: 'Servicios que deseas',
    tres: 'Identificación',
    cuatro: 'Resumen y pago'
  },
  resumen:{
    para: 'para',
    personas: 'persona(s)',
    entrada: 'Entrada:',
    salida: 'Salida:'
  },
  datosReserva:{
    selecciona: 'Selecciona tipo de alojamiento',
    sistema: 'Sistema de reservas',
    antes: 'Infórmate antes de reservar',
    textoAntes:[
      'Lee atentamente todas las indicaciones que encontrarás en los diferentes pasos para poder realizar tu reserva lo más satisfactoriamente posible.',
      'Al terminar el proceso de reserva online recibirás un correo electrónico con el código y datos de tu reserva. No lo pierdas, lo necesitarás para realizar cualquier tipo de modificación de la misma.',
      'Para anular una reserva deberás ponerte en contacto con el establecimiento.',
      'En los cuadros de ‘observaciones’ podrás indicarnos cualquier cosa que creas necesaria. Cuanta más información nos proporciones mejor podremos atender tu solicitud.',
      'Recuerda que (siempre que exista disponibilidad de plazas), dispones de un tiempo limitado para realizar la reserva (el sistema bloquea las plazas que solicitas hasta que realizas el pago del anticipo correspondiente). Si superas ese tiempo el sistema anulará tu solicitud y deberás iniciar de nuevo el proceso.'
    ],
    fechas:'Información sobre las fechas',
    textoFechas:[
      'Si deseas reservar el mismo día o un día más tarde, no podrás realizar la reserva online, deberás contactar directamente con el establecimiento.',
      'El número máximo de noches a reservar por internet es de 4 noches.'
    ],
    numeroPlazas: 'Número de plazas',
    plazasSelect:'Selecciona el # de personas',
    plazas:'Información sobre las plazas',
    textoPlazas:[
      'El sistema de reservas por Internet tiene a su disposición un número limitado de plazas de cada establecimiento. Si no puedes reservar online contacta por teléfono.',
      'En la mayor parte de los establecimientos de este motor de reservas, las plazas se organizan en habitación compartida, si deseas otro tipo de alojamiento ponte en contacto directamente con el establecimiento.'
    ],
    multiple:{
      cabecera:'Sistema de reservas múltiples:',
      texto:'Consulta disponibilidad en el primer refugio y haz uso de esta herramienta para planificar toda tu ruta.'
    },
    otro:'¿Deseas añadir otro refugio a tu reserva?',
    seleccionaOtro:'Selecciona otro establecimiento',
    otroBtn: 'Añadir a la reserva',
    errorReserva:'Revisa las fechas seleccionadas o el número de personas.',
    continuar:'Continuar',
    errors:{
      cerrado:'No se puede seleccionar un día cerrado',
      completo: 'No se puede seleccionar como día de entrada un día completo',
      online: 'Para reservar este día consulta directamente con el establecimiento',
      salida: 'No se puede seleccionar como día de salida un día cerrado',
      rango: 'No cumple los requisitos para realizar la reserva',
      personas: {
        principio: 'No se pueden reservar ',
        final: ' plazas para el día:'
      }
    }
  },
  datosServicios:{
    selecciona:'Selecciona los servicios',
    fecha: 'Fecha',
    desayuno: 'Desayuno',
    comida: 'Comida',
    picnic: 'Picnic',
    cena: 'Cena',
    pernocta: 'Pernocta',
    observaciones: 'Añade en este apartado cualquier comentario que consideres necesario en relación al servicio que estás reservando',
    btnReserva: 'Tramitar la reserva',
    btnCancelar: 'Cancelar la reserva',
    cerrarCancelar: 'Continuar con la reserva',
    confirmarCancelar: 'Cancelar la reserva',
    textoCancelar: '¿Desea cancelar esta reserva?',
    infoCabecera:'Información sobre los servicios',
    info:'Si el día de entrada calculas que vas a llegar más tarde de las 19 horas, ponte en contacto con el establecimiento para saber si puedes reservar la cena de ese día.',
    otrosServicios:{
      otros:'Otros servicios'
    }
  },
  datosResumen:{
    resumen: 'Resumen de tú reserva',
    entrada: 'Fecha de entrada:',
    salida: 'Fecha de salida:',
    distintos: 'Servicios distintos a la pernocta',
    dia: 'Día',
    totalAdelanto: 'Total adelanto a abonar por refugio:',
    textoAdelanto:[
      'Este importe es únicamente en concepto de anticipo de reserva. Para conocer el total del importe de la reserva se debe consultar el apartado de Precios del establecimiento. Hay que recordar que los descuentos a federados lo son para aquellos federados FEDME y pertenecientes al convenio Europeo de Reciprocidad de Refugios.'
    ],
    total: 'Total adelanto de la reserva:',
    tiempoRestante: 'Tiempo restante para completar la reserva:',
    tiempoFin:'El tiempo para realizar la reserva se ha terminado.',
    pago: 'Identificarse y pagar',
    plazas:'Número de plazas',
    noches:'Número de noches',
    AceptarBtn:'Aceptar y pagar',
    CancelarBtn:'Cancelar reserva',
    cerrarCancelar: 'Continuar con la reserva',
    confirmarCancelar: 'Cancelar la reserva',
    textoCancelar: '¿Desea cancelar esta reserva?'
  },
  datosPersonales:{
    intro: 'Si ya eres usuario registrado de alberguesyrefugios.com',
    mensaje: ['tendrás un acceso rápido y sin esfuerzo', 'a tu información'],
    opcion: 'También puedes',
    continuar: 'continuar sin registrarte',
    nombre:'Nombre',
    apellidos:'Apellidos',
    dni:'DNI/NIE',
    fnac:'Fecha de nacimiento',
    direccion:'Dirección',
    cp:'Código Postal',
    poblacion:'Población',
    provincia:'Provincia',
    pais:'País',
    tfno:'Teléfono',
    club:'Club al que perteneces',
    correoe:'Correo electrónico',
    confirmar:'Confirmar correo electrónico',
    registro:'¿Deseas darte de alta en nuestra plataforma de reservas con estos datos?',
    observaciones: 'Añade en este apartado cualquier comentario que consideres necesario en relación a la reserva que estás realizando.',
    tarjetainfo: 'He leído la información sobre la Tarjeta Federativa en los Refugios de la FAM',
    infoTarjetaCabecera:'Información sobre las tarjetas federativas',
    infoTarjeta:'En los refugios y albergues gestionados por la FAM, únicamente se admite como documento acreditativo de estar Federado (y por tanto tener descuento en los precios), la presentación de la tarjeta federativa de aquella comunidad que esté dentro del acuerdo de correspondencia mutua de refugios, bien sea licencia autonómica o nacional.',
    informacion:'Deseo recibir información y noticias sobre refugios y albergues',
    conformidad: {
      acepto: 'Acepto las',
      y:'y la'
    },
    condiciones:'condiciones de reserva',
    proteccion:{
      acepto: 'Acepto la',
      datos: 'ley de protección de datos'
    },
    AceptarBtn:'Aceptar y pagar',
    CancelarBtn:'Cancelar reserva',
    cerrarCancelar: 'Continuar con la reserva',
    confirmarCancelar: 'Cancelar la reserva',
    textoCancelar: '¿Desea cancelar esta reserva?',
    legal:{
      condiciones:{
        titulo:'CONDICIONES SOBRE LA RESERVA ON-LINE',
        generales: {
          titulo: 'Condiciones generales',
          texto:[
            'La realización de una reserva lleva a la aceptación de las normas de funcionamiento y horarios del establecimiento sobre el que se haga.',
            'Los establecimientos que aparecen en esta página son en su mayoría albergues y refugios de montaña. En este tipo de establecimientos, y salvo excepciones concretas, el alojamiento es en habitación múltiple compartida, siendo en muchos casos necesario el uso de saco de dormir o similar.',
            'En muchos de los establecimientos los menús que se sirven son cerrados, y no existe la posibilidad de elegir entre varios platos o una carta.',
            'Es necesario haber consultado el apartado "Cómo llegar" antes de realizar una reserva, algunos de los refugios son de altura y a ellos solamente se puede llegar caminando.',
            'Para anular o modificar una reserva deberás ponerte en contacto con el establecimiento.'
          ]
        },
        anticipo: {
          titulo: 'Anticipo de reserva',
          inicio: [
            'Para la realización de una reserva online es necesario pagar un anticipo de la misma. La cuantía de dicho importe está en función de los servicios que se reserven.',
            'Las condiciones de devolución del mismo son las siguientes:'
          ],
          lista:[
            'Si las reservas se anulan antes de 6 días de la fecha de la reserva, se devolverá el 100% del anticipo cobrado menos los costes de gestión de la devolución y del motor de reservas si éstos se originasen.',
            'Si se anulan en los últimos 5 días de la fecha de la reserva, se cobrará el 100% del total del anticipo.',
            'Los gastos de devolución son 1€ más 0,25€ por persona y pernocta hasta un máximo de 5€.'
          ],
          fin:[
            'En caso de "fuerza mayor" se devolverá el 100% del anticipo ingresado. Este concepto de "fuerza mayor" tendría que considerarlo el gestor del establecimiento, decidiendo si un caso de anulación de reserva es o no de “fuerza mayor”, y si la parte que reserva discrepa con la decisión del guarda, puede remitirse entonces a la entidad gestora.',
            'En los establecimientos de la F.A.M. existen unos horarios límite de llegada para disponer de la plaza reservada. Si no se cumplen estos horarios, la plaza quedará libre para los usuarios que la demanden. Consultar las condiciones del reglamento para cada refugio.'
          ]
        }
      }
    },
    avisoLegal:{
      tituloGeneral:'Aviso legal',
      info:{
        titulo: 'Información legal',
        texto:[
          'En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (LSSICE) presentamos la siguiente información:',
          '',
          'Razón Social: Federación Aragonesa de Montañismo',
          'Dirección: C/. Albareda 7, 4º 4ª, 50004. Zaragoza',
          'C.I.F.: V50120211',
          'Teléfono: 976227971',
          'E-mail: fam@fam.es',
          'Datos de la inscripción en el Registro de Federaciones: 05/3',
          '',
          'Razón Social: PRAMES S.A.',
          'Dirección: Camino de los Molinos, 32. 50015. Zaragoza.',
          'C.I.F: A50223031',
          'Teléfono: 976106170',
          'E-mail: lopd@prames.com',
          'Datos de la Inscripción en el Registro Mercantil: 10.086 Folio: 185 Tomo: 841',

        ]
      },
      proteccion:{
        titulo: 'Protección de datos',
        texto:[
          '1. Completando el formulario de registro o de contacto, enviando un correo electrónico o llamando por teléfono, sus datos personales pasarán a ser responsabilidad de la empresa cuyos datos se relacionan en el apartado 1. Información Legal.',
          '2. Estos datos se utilizan para responder a su solicitud o consulta a la mayor brevedad posible porque usted nos los proporciona informada y libremente con esa finalidad.',
          'También nos comunicaremos comercialmente por medios electrónicos con nuestros clientes con base en nuestro interés legítimo de ofrecerles productos y servicios similares a los que inicialmente nos contrataron.',
          'Para otros tratamientos o finalidades relacionados con la prestación de nuestros servicios o el desarrollo de nuestra actividad, usted puede obtener más información en la Política de Privacidad de PRAMES, S.A. o solicitarlos en nuestra dirección de contacto.',
          '3. Los datos personales recogidos en nuestra página web son tratados cumpliendo con las exigencias del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos.',
          '4. Una vez los datos no sean necesarios para los fines con los que fueron recogidos, se conservarán a disposición de las administraciones públicas competentes durante los plazos legales de conservación, es decir mientras una ley nos pueda exigir que los presentemos. Expirados estos plazos se mantendrán bloqueados hasta que sea posible su posterior destrucción o supresión.',
          '5. Puede ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad sobre los datos de carácter personal presentando una copia de un documento identificativo en: fam@fam.es',
          '6. Puede revocar el consentimiento prestado para el envío de comunicaciones electrónicas en el momento de hacer la reserva, en la dirección anteriormente mencionada.',
          '7. Puede encontrar más información sobre sus derechos o presentar una reclamación ante la autoridad de control competente en la Agencia Española de Protección de Datos http://www.agpd.es - C/ Jorge Juan, 6. 28001 – Madrid (901 100 099 - 912 663 517).'
        ]
      },
      limitacion:{
        titulo: 'Limitación de Responsabilidades',
        texto: [
          '1. La Federación Aragonesa de Montañismo proporciona el sitio web corporativo como medio de dar a conocer sus actividades y servicios, y permitir el contacto con los federados. La información de la página web se presenta de modo meramente orientativo o divulgativo y en ningún momento será considerada vinculante.',
          '2. La entidad no se responsabiliza sobre los posibles daños informáticos que pueda sufrir el usuario mientras visita nuestra página web entendiendo que aquellos no puedan ser imputables a la entidad.',
          '3. La entidad tampoco se responsabiliza del contenido de los sitios gestionados por terceros que se enlacen desde la página web, así mismo dichos enlaces no implicarán la existencia de algún tipo de relación por parte de la Federación Aragonesa de Montañismo con esos terceros.'
        ]
      },
      propiedad:{
        titulo: 'Propiedad Intelectual',
        texto: [
          '1. Todos los contenidos de esta página web entendiendo como tales los textos, dibujos, gráficos, fotografías, imágenes, vídeos, música, código, el propio diseño de la misma y cualquier otra creación son propiedad de Federación Aragonesa de Montañismo y PRAMES SA o de sus respectivos titulares mediante la correspondiente licencia, autorización o cesión sobre los derechos y están protegidos en función de la legislación sobre la Propiedad Intelectual e Industrial.',
          '2. En ningún caso se entenderá que la puesta a disposición del público de la página web constituye renuncia, cesión o licencia de los derechos que Federación Aragonesa de Montañismo y PRAMES, S.A. tienen sobre los contenidos de la misma.',
          '3. Queda prohibido cualquier uso de los contenidos de nuestra página web incluida la modificación, copia, reproducción, transmisión, etcétera sin la previa autorización por escrito de la entidad.'
        ]
      }
    },
    seguro: {
      titulo: 'Atención',
      texto: [
        'alberguesyrefugios.com utiliza el pago seguro.',
        'Comprueba que tu tarjeta tiene el pago seguro activado, antes de confirmar la reserva.'
      ]
    },
    btnPagar:'Confirmar datos',
    errores:{
      nombre:'Este campo es obligatorio. Debe de tener 3 caracteres o más',
      apellidos:'Este campo es obligatorio. Debe de tener 3 caracteres o más',
      dni:'Este campo es obligatorio. El formato debe de ser 12345678Z',
      fnac:'Este campo es obligatorio y debes de ser mayor de edad.',
      direccion:'Este campo es obligatorio. Debe de tener 3 caracteres o más',
      cp:'Este campo es obligatorio. Debe de tener 5 caracteres',
      poblacion:'Necesitamos saber este dato.',
      provincia:'Es necesario esta información.',
      pais:'Necesitamos saber esto',
      correo:'Este campo es obligatorio. Debe de tener formato de email.',
      confirmarCorreo:'Los correos deben de coincidir',
      tfno:'Este campo es obligatorio. Debe de tener 9 caracteres.',
      club:''
    },
    login:{
      btnRegistrado:'inicia sesión',
      btnNuevo: 'Quiero reservar',
      saludo:'Hola ',
      info:'Estos datos se usarán para realizar la reserva. No se modifican en tu ficha.',
      btnSalir:'Salir y cancelar la reserva',
      cerrarCancelar: 'Continuar con la reserva',
      confirmarCancelar: 'Cancelar la reserva',
      textoCancelar: '¿Desea cancelar esta reserva?',
      modal:{
        titulo:'Identificarse',
        olvido: '¿Olvidaste la contraseña?',
        usuario:'Email',
        password:'Contraseña',
        error: 'No hemos podido encontrarte con estos datos',
        btnCancelar:'Cancelar',
        btnAceptar:'Aceptar'
      }
    },
    tituloExiste: 'Usuario registrado',
    existe: 'Ya existe un usuario registrado con este correo',
    covid: {
      pre:'Acepto las',
      anchor: 'nuevas condiciones',
      post: 'por el COVID19'
    }
  }
});



// WEBPACK FOOTER //
// ./src/_locale/translations/es.js